import { render, staticRenderFns } from "./07-Capture_face.vue?vue&type=template&id=488a3e3b&scoped=true&"
import script from "./07-Capture_face.vue?vue&type=script&lang=js&"
export * from "./07-Capture_face.vue?vue&type=script&lang=js&"
import style0 from "./07-Capture_face.vue?vue&type=style&index=0&id=488a3e3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488a3e3b",
  null
  
)

export default component.exports